import { render, staticRenderFns } from "./BaseTextAreaHtml.vue?vue&type=template&id=01a691d9&scoped=true&"
import script from "./BaseTextAreaHtml.vue?vue&type=script&lang=js&"
export * from "./BaseTextAreaHtml.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextAreaHtml.vue?vue&type=style&index=0&id=01a691d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a691d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a691d9')) {
      api.createRecord('01a691d9', component.options)
    } else {
      api.reload('01a691d9', component.options)
    }
    module.hot.accept("./BaseTextAreaHtml.vue?vue&type=template&id=01a691d9&scoped=true&", function () {
      api.rerender('01a691d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTextAreaHtml.vue"
export default component.exports